<template>
  <v-menu
    v-model="dateMenu"
    ref="dateMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    nudge-bottom="60"
    nudge-right="100"
    min-width="290px"
    max-width="290px"
    ><template v-slot:activator="{ on, attrs }">
      <v-text-field
        class="m-0 p-0"
        v-model="dateRangeText"
        v-bind="attrs"
        autocomplete="off"
        label="Date Range"
        hint="DD/MM/YYYY - DD/MM/YYYY format"
        persistent-hint
        prepend-inner-icon="mdi-calendar"
        clearable
        @blur="dates = parseDates(dateRangeText)"
        :error-messages="dateRangeTextError"
        v-on="on"
        outlined
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="dates"
      range
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    dateRange: {
      type: Array,
      default: undefined
    },
  },
  created() {
    this.dates = this.dateRange || [];
  },
  data: () => ({
    dateMenu: false,
    dates: [],
    dateRangeText: "",
    dateRangeTextError: "",
  }),
  watch: {
    dates() {
      this.dateRangeText = this.dates.map(this.formatDate).join(" - ");
      this.dateRangeTextError = "";
      this.$emit("onDates", [...this.dates]);
    },
  },
  methods: {
    parseDate(date) {
      if (!date) return "";
      return this.$options.filters.parseSlashedDate(date);
    },
    formatDate(date) {
      if (!date) return "";
      return this.$options.filters.formatDate(date);
    },
    parseDates(dateRangeText) {
      if (!dateRangeText) {
          return [];
      }
      const reg = /(\d{1,2}\/\d{1,2}\/\d{4})\s*(-\s*(\d{1,2}\/\d{1,2}\/\d{4})$)?/;
      if (!dateRangeText.match(reg)) {
        this.dateRangeTextError = "Invalid date range";
        return this.dates;
      }
      const dates = dateRangeText.split("-").map((dateStr) => dateStr.trim());

      const parsedDates = dates
        .filter((str) => str !== "")
        .map(this.parseDate)
        .filter((str) => str !== "");
      if (parsedDates.filter((str) => isNaN(Date.parse(str))).length > 0) {
        return this.dates;
      }
      this.dateRangeTextError = "";
      return parsedDates;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>